import React from "react";
import { MIN_SESSION_MINUTES } from "../utils/guidanceTimes";

// Renders the "suggest N possible times" rows shared by GuidancePage
// (initial request) and GuidanceRespond (resubmit after a decline). Each row
// lets the visitor pick "exact time" or "a range" — a range gives Pooja a
// window to place the 30-minute session in, instead of one fixed instant.
export default function TimeSlotsEditor({ times, setTimes, minTimes, maxTimes }) {
  const setField = (i, field, value) => {
    setTimes(prev => prev.map((t, idx) => (idx === i ? { ...t, [field]: value } : t)));
  };
  const setType = (i, type) => setField(i, "type", type);
  const addRow = () => times.length < maxTimes && setTimes(prev => [...prev, { type: "exact", date: "", time: "", startTime: "", endTime: "" }]);
  const removeRow = (i) => times.length > minTimes && setTimes(prev => prev.filter((_, idx) => idx !== i));

  const today = new Date().toISOString().slice(0, 10);

  return (
    <>
      {times.map((t, i) => (
        <div className="gp-time-row" key={i}>
          <span className="gp-time-index">{i + 1}</span>
          <div className="gp-time-content">
            <div className="gp-time-type-toggle">
              <button
                type="button"
                className={`gp-time-type-btn${t.type !== "range" ? " active" : ""}`}
                onClick={() => setType(i, "exact")}
              >
                Exact time
              </button>
              <button
                type="button"
                className={`gp-time-type-btn${t.type === "range" ? " active" : ""}`}
                onClick={() => setType(i, "range")}
              >
                A range
              </button>
            </div>

            {t.type === "range" ? (
              <>
                <div className="gp-time-fields gp-time-fields-range">
                  <input type="date" min={today} value={t.date} onChange={e => setField(i, "date", e.target.value)} />
                  <input type="time" value={t.startTime} onChange={e => setField(i, "startTime", e.target.value)} />
                  <span className="gp-time-to">to</span>
                  <input type="time" value={t.endTime} onChange={e => setField(i, "endTime", e.target.value)} />
                </div>
                <p className="gp-time-hint">Any {MIN_SESSION_MINUTES} minutes in this window works — Pooja will pick a time inside it.</p>
              </>
            ) : (
              <div className="gp-time-fields">
                <input type="date" min={today} value={t.date} onChange={e => setField(i, "date", e.target.value)} />
                <input type="time" value={t.time} onChange={e => setField(i, "time", e.target.value)} />
              </div>
            )}
          </div>
          {times.length > minTimes && (
            <button type="button" className="gp-time-remove" onClick={() => removeRow(i)} aria-label="Remove this time">×</button>
          )}
        </div>
      ))}

      {times.length < maxTimes && (
        <button type="button" className="gp-time-add" onClick={addRow}>
          + Suggest another time
        </button>
      )}
    </>
  );
}
